import MobileMenuContent from './common/MobileMenuContent'

const MobileMenu = () => {
  return (
    <footer className="px-4 sticky bottom-0 z-20 bg-white shadow-[0_4px_13px_#717173] text-center flex-0">
      <nav className="h-[82px] flex justify-center items-center max-w-screen">
        <MobileMenuContent />
      </nav>
    </footer>
  )
}

export default MobileMenu
